import { useKey } from 'react-use';

import { useFlag } from '../services/launchDarkly';
import { useStores } from '../stores/useStores';

const useClosePopupsShortcut = () => {
  const {
    eventTriggerStore,
    uiStore,
    portalStore,
    userStore,
    hammersStore,
    prizeDropStore,
    puzzleStore,
    userFreeSpinsStore,
    userSnappyGiftsStore,
    trailStore,
  } = useStores();

  const isSunfl = userStore.profile?.email?.endsWith('@sunfltd.com');
  const allowClosePopupsShortcut = useFlag('web_allow_close_popups_shortcut', isSunfl);

  useKey(
    (event) => event.ctrlKey && ['s', 'ד'].includes(event.key.toLowerCase()),
    () => {
      if (allowClosePopupsShortcut) {
        if (puzzleStore.currentOpenPuzzleEvent) {
          puzzleStore.closeGame();
        } else if (hammersStore.currentOpenHammersEvent) {
          hammersStore.closeGame();
        } else if (prizeDropStore.currentOpenPrizeDropEvent) {
          prizeDropStore.closeGame();
        } else if (userFreeSpinsStore.isDialogOpen) {
          userFreeSpinsStore.closeDialog();
        } else if (portalStore.isVisible) {
          portalStore.closePortal();
        } else if (uiStore.openDialog.dialog) {
          uiStore.setCloseDialog();
        } else if (uiStore.openFullPageDialog) {
          uiStore.closeFullPageDialog();
        } else if (userSnappyGiftsStore.isDialogOpen) {
          userSnappyGiftsStore.closeDialog();
        } else if (trailStore.currentOpenTrailEvent) {
          trailStore.closeGame();
        }
      }

      if (eventTriggerStore.isPopupOpen) {
        void eventTriggerStore.setPopupState({ newIsOpen: false });
      }
    },
  );
};

export default useClosePopupsShortcut;
